module.exports = __webpack_public_path__ + "media/images/icons/icons_large/18_todolist-11c290512c87860fb2313e6b53e0c59f.png";